import React, { useEffect, useRef, useState } from 'react';
import { subscribe } from '../../utility/utils/broadcast';
import { TOPIC } from '../../utility/constants/topicConstants';
import Globals from '../../utility/constants/appConstants';
import Storage from '../../utility/features/helpers/storageHelper';
import styles from '../../styles/GlobalError.module.scss';
export default function GlobalError() {
    const labelsRef = useRef(Globals.globalError || {});
    const forgotPasswordEmailRef = useRef(null);
    const resetPasswordEmailRef = useRef(null);

    const [message, setMessage] = useState('');
    const [Title, setTitle] = useState('');
    const [isError, setIsError] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        forgotPasswordEmailRef.current = Storage.forgotPasswordEmail();
        resetPasswordEmailRef.current = Storage.resetPasswordEmail();
        const unsubscribers = [];

        const maybeUnsub1 = subscribe(TOPIC.API.ERROR, errorHandler);
        if (typeof maybeUnsub1 === 'function') unsubscribers.push(maybeUnsub1);

        const maybeUnsub2 = subscribe(TOPIC.NOTIFY.SUCCESS, showSuccess);
        if (typeof maybeUnsub2 === 'function') unsubscribers.push(maybeUnsub2);

        const maybeUnsub3 = subscribe(TOPIC.API.SUCCESS, showSuccess1);
        if (typeof maybeUnsub3 === 'function') unsubscribers.push(maybeUnsub3);

        const maybeUnsub4 = subscribe(TOPIC.API.LOADING, reset);
        if (typeof maybeUnsub4 === 'function') unsubscribers.push(maybeUnsub4);

        if (forgotPasswordEmailRef.current) {
            Storage.forgotPasswordEmail(null);
            showSuccess(
                'An email including a password-reset link has been sent to ' +
                forgotPasswordEmailRef.current +
                '. Please check your email and follow the link to reset your password.'
            );
        }

        if (resetPasswordEmailRef.current) {
            Storage.resetPasswordEmail(null);
            showSuccess('You have successfully reset your password. Please log in below.');
        }

        return () => {
            unsubscribers.forEach((u) => {
                try {
                    u();
                } catch (e) {

                }
            });
        };
    }, [forgotPasswordEmailRef.current]);

    function errorValueFilter() {
        const globals = Globals && Globals.globalError;
        const labels = labelsRef.current || {};
        if (globals) {
            for (const key in globals) {
                if (!Object.prototype.hasOwnProperty.call(globals, key)) continue;
                const multiKeys = key.split('_');
                if (multiKeys.length === 1) {
                    labels[multiKeys[0]] = globals[key];
                    continue;
                }
                labels[multiKeys[0]] = labels[multiKeys[0]] || {};
                labels[multiKeys[0]][multiKeys[1]] = globals[key];
            }
            labelsRef.current = labels;
        }
        return labelsRef.current;
    }

    const errorHandler = (error) => {
        window.scrollTo(0, 0);

        if (error?.response?.data) {
            const data = error.response.data;

            if (data.errorCode) {
                const errcodereceived = data.errorCode;
                const errcodeformatted = errcodereceived.toString().replace(/_/g, '');
                errorValueFilter();
                const errMsg = labelsRef.current[errcodeformatted];
                setIsError(true);
                setMessage(errMsg);
                return;
            }

            if (data.code !== undefined && data.code !== null) {
                const errcodereceived = data.code;
                const errcodeformatted = 'ERR' + errcodereceived.toString();
                errorValueFilter();
                const errMsg = labelsRef.current[errcodeformatted];
                const errorTitle = labelsRef.current['ERRTITLE' + data.code] || labelsRef.current['ERROR'];
                setIsError(true);
                setMessage(errMsg);
                setTitle(errorTitle);
                return;
            }
        }

        if (Array.isArray(error?.errors) && error.errors.length > 0) {
            const errorCode = error.errors[0].code;
            const errcodeformatted = errorCode.replace(/_/g, '');
            const errMsg = labelsRef.current[errcodeformatted] || error.genericMessage || '';
            setIsError(true);
            setMessage(errMsg);
            return;
        }

        setIsError(true);
        setMessage(error?.genericMessage || '');
    };

    const reset = () => {
        const hasForgot = !!forgotPasswordEmailRef.current;
        const hasReset = !!resetPasswordEmailRef.current;
        setIsError(false);
        setIsSuccess(hasForgot || hasReset ? true : false);
    };

    const showSuccess = (msg) => {
        setIsSuccess(true);
        setMessage(msg);
    };

    const showSuccess1 = (response) => {
        const code = response?.data?.code;
        if (code === 20001) {
            setIsError(true);
            setTitle('Oops');
            setMessage('Your username and/or password does not match our records. Please try again.');
        } else if (code === undefined || code === 200) {
            setIsError(false);
        } else if (code !== '') {
            setIsError(true);
            setTitle('Oops');
            setMessage(response?.data?.message || '');
        }
    };

    const labels = labelsRef.current || {};
    return (
        <>
            {isError && (
                <div className={styles["row"]} id="globalError">
                    <div className={styles["container"]}>
                        <div className={`${styles["alert"]} ${styles["error"]}`}>
                            <div className={styles["innerRow"]}>
                                <div className={styles["iconCol"]}>
                                    <img
                                        src="/images/MyAccount/Icons/error-notification-icon.png"
                                        className={styles["icon"]}
                                        alt="Error"
                                        width="65"
                                    />
                                </div>

                                <div className={styles["textCol"]}>
                                    {Title && (
                                        <div className={styles["titleRow"]}>
                                            <div className={styles["titleCol"]}>
                                                <span className={styles["title"]}>{Title}</span>
                                            </div>
                                        </div>
                                    )}

                                    <div className={styles["messageRow"]}>
                                        <div className={styles["messageCol"]}>
                                            <span className={styles["message"]}>
                                                {message || labels.GenericError}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {isSuccess && (
                <div className={`${styles["row"]} ${styles["successBg"]}`}>
                    <div className={styles["container"]}>
                        <div className={`${styles["alert"]} ${styles["success"]}`}>
                            <div className={styles["innerRow"]}>
                                <div className={styles["iconColSmall"]}>
                                    <img
                                        src="/images/MyAccount/Icons/ico-success-notify.png"
                                        className={styles["icon"]}
                                        alt="Success"
                                        width="65"
                                    />
                                </div>

                                <div className={styles["textCol"]}>
                                    <div className={styles["titleRow"]}>
                                        <div className={styles["titleCol"]}>
                                            <span className={styles["title"]}>{labels.SUCCESS}</span>
                                        </div>
                                    </div>

                                    <div className={styles["messageRow"]}>
                                        <div className={styles["messageCol"]}>
                                            <span className={styles["message"]}>{message}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
